import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import { BannerNotificationType } from "../../components/SimpleBanner";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import CreateCampaignForm from "../../components/forms/campaigns/CreateCampaignForm";

export function CampaignsViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [campaigns, setCampaigns] = useState({ data: [], total: 0 });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });

  const getCampaigns = async function (search, page) {
    setLoading(true);
    try {
      const payload = {
        page: page || 1,
        search: search ?? null,
      };
      const callResult = await makePostApiCall("campaigns", payload);
      if (callResult.success) {
        setCampaigns(callResult.data);
      } else if (callResult.errorStatus === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  };

  const createCampaign = async function (values) {
    const payload = { ...values };
    const callResult = await makePostApiCall("createCampaign", payload);
    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Campaign added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({ childComponent: null, open: false });
      setTimeout(function () {
        getCampaigns(null, 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        setShowSimpleNotification({
          show: true,
          title: callResult.data?.message || "Could not create campaign",
          type: BannerNotificationType.Error,
        });
      }
    }
  };

  const openCreateCampaignSlideOver = () => {
    setSlideOver({
      childComponent: (
        <CreateCampaignForm
          setOpen={setSlideOver}
          actionCall={createCampaign}
        />
      ),
      open: true,
    });
  };

  const deleteCampaign = async function (id) {
    setLoading(true);
    try {
      const callResult = await makePostApiCall(`deleteCampaign/${id}`, {});
      if (callResult.success) {
        setEmptyModelOpen({
          open: false,
          childComponent: null,
        });
        getCampaigns(null, 1);
        setShowSimpleNotification({
          show: true,
          title: callResult.data.message,
          type: BannerNotificationType.Success,
        });
      } else if (callResult.errorStatus === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  };

  const askDeleteCampaign = function (campaign) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteCampaign(campaign.id)}
          message={`Are you sure you want to delete ${campaign.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteCampaign,
    campaigns,
    emptyModal,
    getCampaigns,
    loading,
    openCreateCampaignSlideOver,
    setEmptyModelOpen,
    setSlideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    slideOver,
  };
}
